import clientConfig from '../clientConfig';
import getPreviewModeFromPath from './preview/getPreviewModeFromPath';

export function localeInPath(path: string) {
  const reqPath = (path || '/').toLowerCase();
  const allowedLanguages = [...clientConfig.i18n.whitelist, 'cimode'];

  const { previewMode, previewTenantDomain } = getPreviewModeFromPath(path);
  const isPreviewPath = !!previewMode && !!previewTenantDomain;

  const segments = reqPath.slice(1).split('/');

  const localeIndex = isPreviewPath ? 3 : 1;

  if (segments.length <= localeIndex) {
    return '';
  }

  const potentialLocale = segments[localeIndex];
  const lngIndex = allowedLanguages.indexOf(potentialLocale);

  return lngIndex > -1 ? allowedLanguages[lngIndex] : '';
}

export function localizeRoutePath(path: string) {
  if (path.search(':lng') > -1) {
    const allowedLanguages = [...clientConfig.i18n.whitelist, 'cimode'].join(
      '|',
    );
    return path.replace(':lng', `:lng(${allowedLanguages})?`);
  }

  return path;
}

export function localizePath(path: string, lng = '', primaryLng = '') {
  let pathname = path;
  if (localeInPath(pathname)) {
    pathname = deLocalizePath(pathname);
  }

  if (!lng || lng.toLowerCase() === primaryLng) {
    return pathname;
  }

  const { previewMode, previewTenantDomain } = getPreviewModeFromPath(pathname);
  const isPreviewPath = !!previewMode && !!previewTenantDomain;

  if (isPreviewPath) {
    const pathArr = pathname
      .slice(1)
      .split('/')
      .filter((s) => s.length);

    pathArr.splice(3, 0, lng.toLowerCase());
    return '/' + pathArr.join('/') + '/';
  } else {
    const pathArr = pathname
      .slice(1)
      .split('/')
      .filter((s) => s.length);

    pathArr.splice(1, 0, lng.toLowerCase());
    return '/' + pathArr.join('/') + '/';
  }
}

export function deLocalizePath(path: string) {
  const pathLng = localeInPath(path);

  if (!pathLng) {
    return path;
  }

  const allowedLanguages = [...clientConfig.i18n.whitelist, 'cimode'];

  const { previewMode, previewTenantDomain } = getPreviewModeFromPath(path);
  const isPreviewPath = !!previewMode && !!previewTenantDomain;

  const pathArr = path
    .slice(1)
    .split('/')
    .filter((s) => s.length);

  if (isPreviewPath) {
    if (pathArr.length > 3 && allowedLanguages.includes(pathArr[3])) {
      pathArr.splice(3, 1);
    }
  } else {
    if (pathArr.length > 1 && allowedLanguages.includes(pathArr[1])) {
      pathArr.splice(1, 1);
    }
  }

  return '/' + pathArr.join('/');
}
